import React, { useContext } from 'react';
import { appContext } from '../../App';
import { lang } from '../../util/constants';
import familySmall from '../../images/family-small.jpeg';
import family from '../../images/family.jpeg';

import './intro.css'

const WhoIsAllan = () => {

   const { language } = useContext(appContext);
   
   return (
      <main>
         <div className='introduction padd d-flex flex-column align-items-center'>
            <p className='intro-1'>{language === lang.pt ? msg1.pt : msg1.en}</p>
            <div className='intro-bible'>
               <p className='intro-bible-verse'>{language === lang.pt ? bible.pt.passage : bible.en.passage}</p>
               <p className='intro-verse-location'>{language === lang.pt ? bible.pt.verse : bible.en.verse}</p>
            </div>
            <h2>{language === lang.pt ? 'O Chá do Allan' : 'Allan\'s baby shower'}</h2>
            <p>{language === lang.pt ? msg2.pt : msg2.en}</p>
            <div>{language === lang.pt ? 'Com amor,' : 'With love,'}</div>
            <div>Bruno, Kályta, Clarissa e Allan.</div>
            <div className='i-picture d-flex justify-content-center'>
               <img src={familySmall} alt='Family Lima' />
            </div>
         </div>
      </main>
   )
}

const msg1 = {
   pt: 'Olá, sejam bem vindos ao chá de bebê online do Allan Baltazar. Estamos muito felizes com a chegada de mais um filho da aliança e queremos compartilhar com você essa nossa alegria.',
   en: 'Hi, welcome to the Allan Baltazar\'s baby shower online. We are very happy with the coming of one more covenant child and we want to share this happiness with you.'
}

const bible = {
   pt: {
      passage: 'Herança do Senhor são os filhos; o fruto do ventre, seu galardão.',
      verse: 'Salmos 127:3'
   },
   en: {
      passage: 'Behold, children are a heritage from the Lord, The fruit of the womb is a reward.',
      verse: 'Psalms 127:3'
   }
}

const msg2 = {
   pt: 'O Allan está chegando!! Yeaahhh Que bom que você veio até aqui para nos ajudar. Será um desafio grande começar esse novo ciclo sem o suporte e presença das pessoas mais importantes pra nós. Mas ficamos muito felizes em saber que de alguma forma você se preocupa com a gente e quer estar presente nas nossas vidas independente da distância física. Desde já muito obrigada por visitar a nossa lista, Um abraço bem apertado e cheio de saudade dos nossos amigos e família.',
   en: "Allan is coming!! Yeaahhh, it's nice that you came here to help us. It's going to be a big challenge to start this phase without the support and presence of the most important people for us. But we are very happy to know that in some way you worry about us and want to be present in our lives independent of the physical distance. Thank you so much for visiting our wishlist. We miss all our friends and family."
}

export default WhoIsAllan
